import { FuseAnimate } from "@fuse";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
});

const PagamentoPendente = (props) => {
    const { data = null, classes } = props;

    const showDetalhes = Boolean(data?.showdetalhes);

    function getColumns() {
        return [
            {
                Header: "Vencimento",
                accessor: "vencimentodescricao",
                align: "center"
            },
            {
                Header: "Valor",
                accessor: "valor",
                align: "center"
            },
            {
                Header: "Descrição",
                accessor: "descricao"
            },
            {
                Header: "Status",
                accessor: "status",
                align: "center"
            },
            {
                Header: "Ação",
                accessor: "actions",
                align: "center"
            }
        ];
    }

    function getCellContent(column, row) {
        switch (column.accessor) {
            case "actions": {
                switch (row.status) {
                    case "OVERDUE":
                    case "PENDING": return (
                        <div className="flex w-full items-center gap-8 justify-center">
                            <XAPPButton
                                tooltip={{ "title": "Efetuar pagamento", "placement": "top" }}
                                type="Button"
                                color="primary"
                                className=""
                                label="Pagar"
                                variant="outlined"
                                iconProps="mr-8"
                                component="a"
                                target="_blank"
                                href={row.url}
                                icon={"cifrao"}
                            />
                        </div>
                    );
                    default: return <div />
                }
            };
            case "status": {
                let ACor = "";
                switch (row.status) {
                    case "RECEIVED": ACor = "bg-green-dark"; break;
                    case "PENDING": ACor = "bg-yellow-dark"; break;
                    case "CONFIRMED": ACor = "bg-blue-dark"; break;
                    case "OVERDUE": ACor = "bg-red-dark"; break;
                    case "REFUNDED": ACor = "bg-grey-darker"; break;
                    default: ACor = ""; break;
                }
                return (
                    <div className={clsx("py-8 rounded-full text-white", ACor)}>
                        {row.statusdescricao}
                    </div>
                )
            };
            case "valor": return formatter.format(row.valor);
            default: return row[column.accessor];
        }
    }

    return (
        <React.Fragment>
            {showDetalhes ?
                <Typography color="textSecondary" className="blocb font-medium text-16 my-16 indent-6">
                    {"Olá, identificamos alguns pagamentos em atraso na sua assinatura. Para regularizar efetue os pagamentos abaixo"}
                </Typography>
                :
                <Typography color="textSecondary" className="blocb font-medium text-16 my-16 indent-6">
                    {"Olá, identificamos problema que requer a ação do usuário administrador do sistema. Por gentileza informe o usuário administrador a necessidade de sua interação na sessão de mensagens / alertas"}
                </Typography>
            }
            {showDetalhes &&
                <FuseAnimate>
                    <Table className="min-w-full" aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow className="h-64">
                                {getColumns().map(column => (
                                    <TableCell
                                        key={column.accessor}
                                        align={"center"}
                                        style={{ padding: "2px 12px 2px 12px" }}
                                    >
                                        {column.Header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {_.orderBy(data?.cachecobrancas, "vencimento", "desc").map((n, y) => {
                                return (
                                    <React.Fragment key={y}>
                                        <TableRow className={clsx("", y % 2 === 0 && classes.anotherLine)}>
                                            {getColumns().map((column, x) => (
                                                <TableCell key={x} component="th" scope="row" align={column.align} style={{ padding: "2px 12px 2px 12px" }}>
                                                    {getCellContent(column, n)}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </FuseAnimate>
            }
        </React.Fragment>
    );
};


PagamentoPendente.propTypes = {
    classes: PropTypes.string,
    data: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(PagamentoPendente);